import { Directive, input } from '@angular/core';

export interface ChartData {
  name: string;
  value: number;
  label?: string;
  link?: string[];
  textColor?: string;
  disableHoverEffect?: boolean;
  tooltipText?: string;
}

export interface DisabledChartText {
  header: string;
  description: string;
}

@Directive({
  selector: '[ziroMigrationsChartAbstract]',
  standalone: false,
})
export class MigrationsCardAbstractDirective {
  readonly isRefreshing = input.required<boolean>();
  readonly isError = input.required<boolean>();
  readonly label = input.required<string>();
  readonly labelTooltip = input.required<string>();
  readonly data = input.required<ChartData[]>();
  readonly isDisabled = input<boolean>(false);
  readonly disabledText = input<DisabledChartText>();
}
